import { admissionToMeetingType } from "../../types/commonTypes/admissionToMeetingType";


export const initialAdmissionToMeetingState: admissionToMeetingType = {
    admissionText: ""
}